import {Inject, Injectable} from "@angular/core";
import {ApiCommunicationService} from "../../../shared/model/services/api-communication/api-communication.service";
import {BehaviorSubject, Observable} from "rxjs";
import {CachedObject} from "../../../shared/model/data/cache/CachedObject";

@Injectable()
export class TagsDataService {

	private storedTags: BehaviorSubject<any> = new BehaviorSubject<CachedObject<any>>(null);

	constructor(@Inject(ApiCommunicationService) private api: ApiCommunicationService) {
	}

	// TODO
	public getTopTags(): Observable<CachedObject<any>> {
		return null;
	}

}
